import "../LibraryBoxBattle.scss";
import Dialog from "../../../1. Core/Controls/Dialog/Dialog";
import NP from "../../../1. Core/NP";
import Select from "../../../1. Core/Controls/Select/Select";

import {ServerAPI} from "../../../1. Core/ServerAPI";
import TextField from "../../../1. Core/Controls/TextField/TextField";
import CreateBoutDialog from "./CreateBoutDialog";
import NumField from "../../../1. Core/Controls/TextField/NumField";
import IconSelect from "../../../1. Core/Controls/Select/IconSelect";
import {
	getStages,
	getTournaments,
	getWeights,
	getWeightString,
	ITournament,
	secondsToTime,
	timeToSec,
	Weight
} from "../../Util";
import ListGroupHeader from "../../../1. Core/Controls/ListBox/ListGroupHeader";
import ListBox from "../../../1. Core/Controls/ListBox/ListBox";
import TimeEdit, {TimeEditMode} from "../../../1. Core/Controls/TimeEdit/TimeEdit";
import './EditBoutDialog.scss';
import {EventTournament, IBattle} from "../../types";
import DateInput from "../../../1. Core/Controls/DateInput/DateInput";
import Button from "../../../1. Core/Controls/Button/Button";
import SelectFighterCtrl from "../../../2. Athletes/SelectFighterCtrl";


let moment = require('moment');

export default class EditBoutDialog extends Dialog {


	private _Battle: IBattle;
	private _winTypeSelect: Select;
	private _dateInput: DateInput;
	private videoStartWorldTime: TextField;
	private _roundCountInput: NumField;
	private _weightCombo: IconSelect;
	private _statusSelect: Select;
	private _endTime: TimeEdit;
	private _startTime: TimeEdit;
	private _chooseWinnerListHeader: ListGroupHeader;
	private _chooseWinnerList: ListBox;
	private _tournamentCombo: IconSelect;
	private _eventInput: IconSelect;

	private _stageCombo: IconSelect;
	private _roundLengthInput: NumField;
	private _winDesc: TextField;
	private _redCombo: SelectFighterCtrl;
	private _blueCombo: SelectFighterCtrl;
	private _currentTEvents: EventTournament[];
	private _fileVideoPath: TextField;
	private _fullVideoHl: TextField;
	private _optimalVideoHl: TextField;
	private _shortlVideoP: TextField;
	private _idValue: TextField;
	private relativeVideoStartTimeEdit: TimeEdit;
	private _winRound: NumField;


	_initFields(settings: object)
	{

		this._Battle = null;

		super._initFields(settings);
		this._Mode = 'FullHeight';
		this._Caption = this._Battle.Name + ` (${this._Battle.Id})`;
		this._CloseOnFrameMouseDown = true;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._OkRK = 'Save'
	}

	_render()
	{
		super._render();
		let dialogContent = NP.createNode(this._contentNode, 'app-list-group');

		this._tournamentCombo = new IconSelect({
			ParentNode: dialogContent,
			FloatingLabel: NP.RM.getString('Tournament'),
			EvItemSelected: async () =>
			{
				this._dateInput.setEnabled(true)
				this.updateEvents()
			}
		});

		let evenContainer = NP.createNode(dialogContent, 'event-info__container');

		this._eventInput = new Select({
			ParentNode: evenContainer,
			FloatingLabel: NP.RM.getString('Event'),
			EvItemSelected: () =>
			{

				let id = this._eventInput.getValue();
				let ev = this._currentTEvents.find(ev => ev.Id == id)
				if (ev.Date)
				{
					this._Battle.Date = moment(ev.Date).toDate();
					this._dateInput.setValue(this._Battle.Date as any);
					this._dateInput.setEnabled(false)
				}
				else
					this._dateInput.setEnabled(true)
			}
		});


		this._stageCombo = new IconSelect({
			ParentNode: dialogContent,
			FloatingLabel: NP.RM.getString('Stage')
		});

		getTournaments(this._Battle.Type).then((res: ITournament[]) =>
		{
			if (this._tournamentCombo)
			{
				let items = res.map(t => ({Value: t.Id, FontImage: NP.FontImages.event, Content: t.Name, Data: t}));
				this._tournamentCombo.addItems(items);
				this._tournamentCombo.setValue(this._Battle.TournamentId);
			}
		});

		if (this._stageCombo)
		{
			let items = getStages().map(s => ({Value: s, FontImage: NP.FontImages.list, Content: s}));
			this._stageCombo.addItems(items);
			if (this._Battle.Stage)
				this._stageCombo.setValue(this._Battle.Stage);
		}

		this._dateInput = new DateInput({
			ParentNode: dialogContent,
			FloatingLabel: NP.RM.getString('Date'),
			FontImage: NP.FontImages.event,
			EnabledEdit: false,
			Value: this._Battle.Date ? moment(this._Battle.Date).toDate() : null,
			EvChanged: () =>
			{
				this._Battle.Date = this._dateInput.getValue();
			}
		});

		this._idValue = new TextField({
			ParentNode: dialogContent,
			FloatingLabel: 'Id',
			Value: this._Battle.GloryFightID,
			EnableEdit: true
		});

		this._fileVideoPath = new TextField({
			ParentNode: dialogContent,
			FloatingLabel: NP.RM.getString('PathToVideoFile'),
			Value: this._Battle.VideoUrl
		})

		this._fullVideoHl = new TextField({
			ParentNode: dialogContent,
			FloatingLabel: 'Full Highlight url',
			Value: this._Battle.HLUrl_Full
		});

		this._optimalVideoHl = new TextField({
			ParentNode: dialogContent,
			FloatingLabel: 'Optimal Highlight url',
			Value: this._Battle.HLUrl_Optimal
		});

		this._shortlVideoP = new TextField({
			ParentNode: dialogContent,
			FloatingLabel: 'Short Highlight url',
			Value: this._Battle.HLUrl_Short
		});

		this.videoStartWorldTime = new TextField({
			ParentNode: dialogContent,
			FloatingLabel: NP.RM.getString('VideoWorldStartTime'),
			FontImage: NP.FontImages.url,
			Value: this._Battle.VideoStartTime
		});

		this.relativeVideoStartTimeEdit = new TimeEdit({
			ParentNode: dialogContent,
			FloatingLabel: NP.RM.getString('RelativeVideoStartTime'),
			FontImage: NP.FontImages.url,
			Value: this._Battle.RelativeVideoStartTime
		});

		this._roundCountInput = new NumField({
			ParentNode: dialogContent,
			SpinEdit: true,
			Value: this._Battle.RoundCount,
			Min: 1,
			Max: 15,
			FloatingLabel: NP.RM.getString('NumberOfRounds')
		});

		this._roundLengthInput = new NumField({
			ParentNode: dialogContent,
			SpinEdit: true,
			Value: this._Battle.RoundLength,
			Min: 1,
			Max: 5,
			FloatingLabel: NP.RM.getString('RoundLength')
		});

		this._weightCombo = new IconSelect({
			ParentNode: dialogContent,
			SpinEdit: true,
			FloatingLabel: NP.RM.getString('WeightCategory')
		});

		this._statusSelect = new Select({
			ParentNode: dialogContent,
			FloatingLabel: NP.RM.getString('Status'),
			Value: this._Battle.Status,
			Items: [
				{RK: 'NotStarted', Value: 'Not started'},
				{RK: 'InProgress', Value: 'In progress'},
				{RK: 'Finished', Value: 'Finished'},
				{RK: 'Canceled', Value: 'Canceled'},
				{RK: 'NoContest', Value: 'NoContest'}
			],
			EvItemSelected: () => this.updateWinnerVis()
		});

		this._startTime = new TimeEdit({
			ParentNode: dialogContent,
			FloatingLabel: NP.RM.getString('StartTime'),
			FontImage: NP.FontImages.url,
			Value: this._Battle.StartTime ? this._Battle.StartTime.split(":")[1] + ":" + this._Battle.StartTime.split(":")[2] : '00:00',
			Mode: TimeEditMode.MinutesSeconds
		});

		this._endTime = new TimeEdit({
			ParentNode: dialogContent,
			FloatingLabel: NP.RM.getString('WinTime'),
			FontImage: NP.FontImages.url,
			Value: this._Battle.EndTime ? this._Battle.EndTime.split(":")[1] + ":" + this._Battle.EndTime.split(":")[2] : '',
			Mode: TimeEditMode.MinutesSeconds
		});

		getWeights({Type: this._Battle.Type}).then((res: Weight[]) =>
		{
			res = res.filter(w => w.Type == this._Battle.Type || w.Id == this._Battle.WeightId);
			let items = res.map(w => ({Value: w.Id, FontImage: NP.FontImages.weight, Content: getWeightString(w)}));
			this._weightCombo.addItems(items);
			this._weightCombo.setValue(this._Battle.WeightId, false);
		});

		this._chooseWinnerListHeader = new ListGroupHeader({
			ParentNode: dialogContent,
			RK: 'Winner'
		});
		this._chooseWinnerList = new ListBox({
			ParentNode: dialogContent,
			Items: [{
				Value: this._Battle.Red,
				Content: this._Battle.RedName,
				IsRadioButton: true
			}, {
				Value: this._Battle.Blue,
				Content: this._Battle.BlueName,
				IsRadioButton: true
			}, {
				Value: 'Draw',
				RK: 'Draw',
				IsRadioButton: true
			}]
		});

		if (this._Battle.Winner)
			this._chooseWinnerList.setValue(this._Battle.Winner);
		else if (this._Battle.Winner == 0)
			this._chooseWinnerList.setValue('Draw');

		this._winTypeSelect = new Select({
			ParentNode: dialogContent,
			FloatingLabel: NP.RM.getString('WinType').replace("{0}:", ""),
			Value: this._Battle.WinType,
			Items: CreateBoutDialog.getWinTypeItems()
		});

		this._winDesc = new TextField({
			ParentNode: dialogContent,
			FloatingLabel: NP.RM.getString('WinDescription'),
			Value: this._Battle.WinDescription
		});


		this._winRound = new NumField({
			ParentNode: dialogContent,
			SpinEdit: true,
			Value: this._Battle.WinRound,
			Min: 1,
			Max: 15,
			FloatingLabel: NP.RM.getString('WinRound')
		});

		this._redCombo = new SelectFighterCtrl({
			ParentNode: dialogContent,
			SportType: this._Battle.Type,
			FloatingLabel: NP.RM.getString('Red'),
			AllowCreateNew: false
		});

		this._blueCombo = new SelectFighterCtrl({
			ParentNode: dialogContent,
			SportType: this._Battle.Type,
			FloatingLabel: NP.RM.getString('Blue'),
			AllowCreateNew: false
		});

		this._redCombo.setValue(this._Battle.Red);
		this._blueCombo.setValue(this._Battle.Blue);

		this.updateWinnerVis();


		let dbtn = new Button({
			RK: 'DeleteVideo',
			EvClick: () =>
			{
				NP.showConfirm({
					RK: 'AreYouS',
					EvOkButtonClick: async () =>
					{
						await ServerAPI.post(`/battle/delete-video/${this._Battle.Id}`);
						this._fileVideoPath.setValue('')
						this._Battle.VideoUrl = '';
					}
				}).show();
			}
		});

		dbtn.getRoot().style.marginRight = 'auto';
		dbtn.getRoot().style.marginLeft = '12px';


		dbtn.putToNode(this._buttonsNode, this._cancelButton.getRoot());
	}

	async updateEvents()
	{
		let response = await ServerAPI.callUiApi("/t-events", {
			Count: 1500,
			Offset: 0,
			TournamentId: this._tournamentCombo.getValue()
		}, 'POST') as { List: EventTournament[], AllCount: number };

		this._currentTEvents = response.List;

		this._eventInput.setItems(response.List.map(ev => ({Content: ev.Name, Value: ev.Id})));

		if (this._Battle.EventId)
			this._eventInput.setValue(this._Battle.EventId);
	}

	updateWinnerVis()
	{
		NP.setIsVisible([this._chooseWinnerList, this._chooseWinnerListHeader, this._winTypeSelect, this._winDesc],
			 this._statusSelect.getValue() != "Not started" && this._statusSelect.getValue() != "Canceled" && this._statusSelect.getValue() != "NoContest");
	}

	async _onOkButtonClick()
	{
		if (this.videoStartWorldTime.getValue().trim())
			if (!moment(this.videoStartWorldTime.getValue(), 'yyyy-MM-dd HH:mm:ss').isValid())
			{
				return NP.showMessage({
					Content: 'VideoStartTime is incorrect format, must be ' + 'yyyy-MM-dd HH:mm:ss'
				})
			}

		if (this._endTime.getValue() && this._statusSelect.getValue() == 'Finished')
		{
			let winRound = this._winRound.getValue();

			let totalBattleSeconds = timeToSec(this._endTime.getValue())

			let minutesInOneRound = this._roundLengthInput.getValue();

			let maxSeconds = winRound * minutesInOneRound * 60;

			let minSeconds = (winRound - 1) * minutesInOneRound * 60;

			if (totalBattleSeconds > maxSeconds)
				return NP.showMessage({
					Content: `End time cannot be more than ${secondsToTime(maxSeconds)}`
				})

			if (minSeconds > totalBattleSeconds  )
				return NP.showMessage({
					Content: `End time cannot be less than ${secondsToTime(minSeconds)}`
				})

		}

		this._Battle.RelativeVideoStartTime = this.relativeVideoStartTimeEdit.getValue() ? this.relativeVideoStartTimeEdit.getValue() : null;

		this._Battle.GloryFightID = this._idValue.getValue();
		this._Battle.Winner = this._chooseWinnerList.getValue() === 'Draw' ? 0 : this._chooseWinnerList.getValue();
		this._Battle.WinType = this._winTypeSelect.getValue();


		this._Battle.VideoStartTime = this.videoStartWorldTime.getValue();
		this._Battle.VideoUrl = this._fileVideoPath.getValue();

		this._Battle.HLUrl_Full = this._fullVideoHl.getValue()
		this._Battle.HLUrl_Optimal = this._optimalVideoHl.getValue()
		this._Battle.HLUrl_Short = this._shortlVideoP.getValue()

		this._Battle.RoundCount = this._roundCountInput.getValue();
		this._Battle.RoundLength = this._roundLengthInput.getValue();
		this._Battle.Status = this._statusSelect.getValue();
		this._Battle.StartTime = this._startTime.getValue() ? '00:' + this._startTime.getValue() : null;
		this._Battle.EndTime = this._endTime.getValue() ? '00:' + this._endTime.getValue() : null;
		this._Battle.WeightId = this._weightCombo.getValue();
		this._Battle.Stage = this._stageCombo.getValue();
		this._Battle.Date = this._Battle.Date ? moment(this._Battle.Date).format('YYYY-MM-DD HH:mm:ss.S') : null;
		this._Battle.TournamentId = this._tournamentCombo.getValue();
		this._Battle.WinDescription = this._winDesc.getValue();
		this._Battle.EventId = this._eventInput.getValue();
		this._Battle.Red = this._redCombo.getValue();
		this._Battle.Blue = this._blueCombo.getValue();

		this._Battle.WinRound = this._winRound.getValue();

		if (this._Battle.Status == 'Not started')
			this._Battle.WinType = null;

		if (this._Battle.Status == 'NoContest')
		{
			this._Battle.WinType = 'NC';
			this._Battle.Winner = null;
		}

		await ServerAPI.post(`/battle/${this._Battle.Id}`, this._Battle);

		let stat = await ServerAPI.post(`/mma/checkGroundGrapple/${this._Battle.Id}`);

		if (stat)
			NP.showMessage({
				Content: stat
			})

		super._onOkButtonClick()
		//ServerAPI.call("BoxDataService.refreshBattleSeries", null, true, false);
	}
}
